import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MetaMenuService} from '../service/meta-menu.service';
import {Menu, MenuItem, MetaMenu} from '../meta.menu';
import {AuthenticationService} from '../../authentication/service/authentication.service';
import {combineLatest} from 'rxjs';

@Component({
  selector: 'lib-menu-bar',
  templateUrl: './menu-bar.component.html',
  styleUrls: ['./menu-bar.component.css'],
  host: {
    '[class.flex-grow-1]': "mode === 'header'",
    '[class.d-flex]': "mode === 'header'"
  }
})
export class MenuBarComponent implements OnInit {

  @Input() mode: 'header' | 'mobile' | 'footer' = 'header';
  @Output() itemClicked = new EventEmitter<void>();

  displayMenuList: Menu[] = [];
  footerMenuList: MenuItem[] = [];
  isCollapsed: { [key: string]: boolean } = {};

  constructor(
    public readonly metaMenuService: MetaMenuService,
    private readonly authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    combineLatest([
      this.metaMenuService.find(),
      this.authenticationService.currentUser$
    ]).subscribe(([menu, user]) => {
      if (this.mode === 'footer') {
        const footerMenu = menu.menuList.find(m => m.label === 'FOOTER');
        this.footerMenuList = footerMenu ? footerMenu.items : [];
        this.displayMenuList = []; // Clear other list
      } else {
        this.displayMenuList = menu.menuList.filter(m => {
          if (m.label === 'FOOTER') {
            return false; // Always exclude footer from header/mobile
          }
          if (m.label === 'Administration') {
            return user?.administrator;
          }
          return true;
        });
        this.footerMenuList = []; // Clear other list
      }

      // Initialize collapsed state for mobile accordion
      this.displayMenuList.forEach(m => {
        this.isCollapsed[m.label] = true;
      });
    });
  }

  toggleCollapse(label: string): void {
    // In mobile accordion, only one menu should be open at a time.
    Object.keys(this.isCollapsed).forEach(key => {
      if (key !== label) {
        this.isCollapsed[key] = true;
      }
    });
    this.isCollapsed[label] = !this.isCollapsed[label];
  }

  onItemClick(): void {
    // Collapse all accordion items
    Object.keys(this.isCollapsed).forEach(key => {
      this.isCollapsed[key] = true;
    });
    // Notify parent to close the main navbar
    this.itemClicked.emit();
  }
}
